// extracted by css-extract-rspack-plugin
export default {"arrowItem":"_fe7aa64","arrow":"_95713fd1","isLeft":"_19560a69"};